module.exports = __webpack_public_path__ + "img/sect4-4.72778b3c.png";